import styled from 'styled-components';

import { NAVBAR_QUERIES } from '../utils';

export const DesktopHeaderWrapper = styled.div`
  display: none;

  ${NAVBAR_QUERIES.headerTabletMinWidth} {
    display: block;
  }
`;

export const MobileHeaderWrapper = styled.div`
  display: block;

  ${NAVBAR_QUERIES.headerTabletMinWidth} {
    display: none;
  }
`;
